var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PacemEventTarget, Watch, PropertyConverters, Utils, Concurrent } from '@pacem/pacem-core';
const DEFAULT_DATA = { current: 0, count: 0, average: 0, max: Number.MIN_VALUE, min: Number.MAX_VALUE };
export class PacemTrackerElement extends PacemEventTarget {
    constructor() {
        super();
        this.data = DEFAULT_DATA;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'entry')
            this._update(val).then(t => this.data = t);
    }
    _update(ne) {
        //var deferred = DeferPromise.defer<TrackingData>();
        let fn = () => {
            const data = this.data, min = Math.min(ne, data.min), max = Math.max(ne, data.max), count = data.count + 1, average = (data.count * data.average + ne) / count;
            return { count: count, min: min, max: max, average: average, current: ne };
        };
        return Utils.fromResultAsync(fn);
        //return Utils.fromResult/*Async*/(fn());
    }
    reset() {
        this.data = DEFAULT_DATA;
    }
}
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemTrackerElement.prototype, "data", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTrackerElement.prototype, "entry", void 0);
__decorate([
    Concurrent()
], PacemTrackerElement.prototype, "_update", null);
//}
